module.exports = __webpack_public_path__ + "img/broadcast-test-icon4.a6dfea61.png";